import React, { useCallback, useEffect, useState } from 'react';
import Mesh from '../Mesh/Mesh';
import Modal from '../../../../../../components/Modals/Modal';

import styles from './ViewMesh-styles.module.scss';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { firePanelDetail } from '../../../../../../redux/thunks/firepanel';
import classnames from 'classnames';

import Dropdown from '../../../../../../components/Inputs/Dropdown';

import Button from '../../../../../../components/Buttons/Button';
import OutlineButton from '../../../../../../components/OutlineButton/OutlineButton';
import { Dialog, DialogTitle } from '@material-ui/core';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import Typography from '../../../../../../components/Typography/Typography';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import SButton from '../../../../../../components/SButton/SButton';
import SDialog from '../../../../../../components/SDialog/SDialog';

const ViewMesh = ({ togglePopup, data }) => {
  const { customerId } = useParams();
  //redux
  const dispatch = useDispatch();
  const currentPartner = useSelector((state) => state.auth.currentPartner);
  //state
  const [selectedMesh, setMesh] = useState(undefined);
  const [meshData, setMeshData] = useState(() => data || {});

  // console.log(meshData.meshios);

  const popupToggle = (status) => {
    togglePopup && togglePopup(status);
  };

  const handleChange = useCallback(
    (mesh) => {
      setMesh(mesh);
    },
    [setMesh],
  );

  const getDetail = useCallback(() => {
    dispatch(
      firePanelDetail(currentPartner.partnerId, customerId, data.id, (status, details) => {
        if (status === 'success') {
          setMeshData(details);
        }
      }),
    );
  }, [currentPartner.partnerId, customerId, data.id, dispatch, setMeshData]);

  useEffect(() => {
    // getDetail();
    // setMeshData(data);
  }, [getDetail, setMeshData, data]);

  useEffect(() => {
    if (meshData?.meshios && meshData?.meshios.length > 0) {
      setMesh(meshData?.meshios[0]);
    }
  }, [meshData?.meshios, setMesh]);

  return (
    <SDialog
      title='View Mesh I/O'
      width='50%'
      isFormDialog={true}
      open={true}
      onClose={() => popupToggle(false)}
      secondaryButtonConfig={{
        text: 'Edit Mesh I/O',
        onClick: () => {
          popupToggle(true);
        }
      }}
      primaryButtonConfig={{
        text: 'Done',
        onClick: () => {
          popupToggle(false);
        }
      }}
    >
      <FlexColumn flexWrap='nowrap'>
        <FlexRow justifyContent='space-between'>
          <FlexColumn width='10rem'>
            {meshData?.meshios && (
              <Dropdown
                name="site"
                type="dropDown"
                placeholder="Mesh"
                value={selectedMesh?.name ? selectedMesh?.name : ''}
                onChange={handleChange}
                data={meshData?.meshios || []}
              />
            )}
          </FlexColumn>
        </FlexRow>
        <FlexRow justifyContent='space-between'>
          <FlexColumn alignItems='start' gap='0' width='fit-content'>
            <Typography variant={"b2R"} color='var(--brand-500)'>Fire Panel</Typography>
            <Typography variant={"b2R"} color='var(--grey-700)'>{meshData?.name}</Typography>
          </FlexColumn>

          <FlexColumn alignItems='start' gap='0' width='fit-content'>
            <Typography variant={"b2R"} color='var(--brand-500)'>Site Name</Typography>
            <Typography variant={"b2R"} color='var(--grey-700)'>{meshData?.siteName}</Typography>
          </FlexColumn>
        </FlexRow>
        <div style={{padding:'2.5rem 0'}} className={classnames(styles['container'])}>
          <div className={styles['mrb-2']}>
            <Mesh
              title={selectedMesh?.name ? selectedMesh?.name : ''}
              pinData={selectedMesh?.pins ? selectedMesh?.pins : []}
            />
          </div>
        </div>
      </FlexColumn>
    </SDialog>
  );
};

export default ViewMesh;
